import React from 'react';
import QuickLinks from '../common/QuickLinks';
import { useLocation } from 'react-router-dom';

const TheSidebar = () => {
  const { pathname } = useLocation();
  return (
    <div className="sidebar mt-4">
      {pathname !== '/' && (
        <>
          <QuickLinks />
        </>
      )}
    </div>
  );
};

export default TheSidebar;
